export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const DETAILS = 'DETAILS';
export const PEOPLESECTIONDATA = 'PEOPLESECTIONDATA';
export const COLLATERALDATA = 'COLLATERALDATA';
export const RELATEDASSETS = 'RELATEDASSETS';
export const SET_DETAILPAGE_RESULT = 'SET_DETAILPAGE_RESULT';
export const RESET_ADDITIONAL_DETAILS = 'RESET_ADDITIONAL_DETAILS';
export const LOADER = 'LOADER';
export const GLOSSARYDATA = 'GLOSSARYDATA';
export const WHATSNEWDATA = 'WHATSNEWDATA';
export const NEWJOINERDATA = 'NEWJOINERDATA';
export const GET_TOPIC_COLLECTION = 'GET_TOPIC_COLLECTION';
export const GET_POPULAR_COLLECTION = 'GET_POPULAR_COLLECTION';
export const GET_RECENTLY_VIEW_COLLECTION = 'GET_RECENTLY_VIEW_COLLECTION';
export const GET_SEARCH_RESULTS = 'GET_SEARCH_RESULTS';
export const STACK_SEARCH_RESULTS = 'STACK_SEARCH_RESULTS';
export const SEARCH_LOADER = 'SEARCH_LOADER';
export const SAVE_HISTORY_STATE = 'SAVE_HISTORY_STATE';
export const RESET_SEARCH_RESULT = 'RESET_SEARCH_RESULT';
export const GET_CONFIGURATION_DATA = 'GET_CONFIGURATION_DATA';
export const GET_TERM_STORE = 'GET_TERM_STORE';
export const PROFILE_PHOTO = 'PROFILE_PHOTO';
export const SEARCH_BASED_REFINERS = 'SEARCH_BASED_REFINERS';
export const PAGE_LEVEL_REFINER = 'PAGE_LEVEL_REFINER';
export const GET_SEARCH_RESULT_REFINER_DATA = "GET_SEARCH_RESULT_REFINER_DATA";
export const HOME_SECTIONS_LOADER = "HOME_SECTIONS_LOADER";
export const RESET_HOME_SEARCH_RESULT = "RESET_HOME_SEARCH_RESULT";
export const GET_TOPIC_DATA = "GET_TOPIC_DATA";
export const CART_COMPARE_DATA = "CART_COMPARE_DATA";
export const CART_OPEN = "CART_OPEN";
export const GET_SEARCH_SUGGESTIONS = "GET_SEARCH_SUGGESTIONS";
export const GET_TOGGLE_DATA = "GET_TOGGLE_DATA";
export const GET_CONTACT_COLLECTION = "GET_CONTACT_COLLECTION";
export const ADD_SELECTED_ASSETS_PILLS_COLLECTION = "ADD_SELECTED_ASSETS_PILLS_COLLECTION";
export const GET_API_RESPONSE_STATUS = "GET_API_RESPONSE_STATUS";
export const CHK_HOME_COMPONENT = "CHK_HOME_COMPONENT";
export const GET_CLIENT_DATA = 'GET_CLIENT_DATA';
export const GET_DP_DATA = 'GET_DP_DATA';
export const GET_BU_DATA = 'GET_BU_DATA';
export const CLIENT_DATA_SEARCH = 'CLIENT_DATA_SEARCH';
export const RESET_CLIENT_DATA = 'RESET_CLIENT_DATA';
export const RESET_DP_DATA = 'RESET_DP_DATA';
export const RESET_BU_DATA = 'RESET_BU_DATA';
export const RESET_CLIENT_DATA_SEARCH = 'RESET_CLIENT_DATA_SEARCH';